var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "kexie" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "activity-introduce" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "activity-introduce-content" }, [
        _c("div", { staticClass: "activity-introduce-content-text" }, [
          _c("p", [
            _vm._v(
              "活动内容： “ 玩转编程日 ” 线上主题活动设 Scratch、Python 和智能设计三个项目，全国各地中小学生均可参加不同项目的活动。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                `活动形式：活动以线上方式进行，活动专题页面： https://roborobo.${_vm.institutionConfig.baseDomainName}/playCode。学生可直接通过互联网注册报名参加活动。`
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("p", { staticClass: "prompt" }, [
          _vm._v("注： 具体时间安排请点击下方赛项，进入赛项主页查看详情"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "activity-contest" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "activity-contest-content" }, [
        _c("div", { staticClass: "originality" }, [
          _c("h4", [_vm._v("创意编程")]),
          _vm._v(" "),
          _c("div", { staticClass: "originality-card-box" }, [
            _c("div", { staticClass: "contest-card" }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: require("@/assets/kexie/regen/u26.svg") },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-btn-box",
                  on: {
                    click: function ($event) {
                      return _vm.goSignUp("161058993861214208")
                    },
                  },
                },
                [_c("span", [_vm._v("我要报名")])]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "card-type" }, [
                _vm._v("Scratch编程项目"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contest-card" }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: require("@/assets/kexie/regen/u29.svg") },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-btn-box",
                  on: {
                    click: function ($event) {
                      return _vm.goSignUp("161067101098422272")
                    },
                  },
                },
                [_c("span", [_vm._v("我要报名")])]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "card-type" }, [
                _vm._v("Python编程项目"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(5),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(6),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "herder" }, [
      _c("img", {
        staticClass: "header-img",
        attrs: { src: require("@/assets/kexie/regen/u4.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "activity-theme" }, [
      _c("div", { staticClass: "activity-theme-title" }, [
        _c("img", {
          staticClass: "activity-theme-bg",
          attrs: { src: require("@/assets/kexie/regen/u5.png") },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "line" }),
        _vm._v(" "),
        _c("span", [_vm._v("活动主题")]),
        _vm._v(" "),
        _c("span", { staticClass: "line" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "activity-theme-content" }, [
        _c("img", {
          staticClass: "img-left",
          attrs: { src: require("@/assets/kexie/regen/u11.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-content" }, [
          _c("h3", [_vm._v("“玩转编程日”线上主题活动")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "为了给广大青少年编程爱好者搭建实践和交流的平台，拓展青少年编程活动覆盖面，中国科协青少年科技中心将于 2020 年 12 月 1 日 -2020 年 12 月 31 日持续开展 “ 玩转编程日 ” 线上主题活动，为广大青少年和参与者提供持续性的学习体验和展示交流机会。"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "activity-introduce-title" }, [
      _c("span", { staticClass: "line" }),
      _vm._v(" "),
      _c("span", [_vm._v("活动介绍")]),
      _vm._v(" "),
      _c("span", { staticClass: "line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-content" }, [
      _c("div", { staticClass: "text-box" }, [
        _c("span", { staticClass: "title" }, [_vm._v("注册报名")]),
        _vm._v(" "),
        _c("span", [_vm._v("2020年12月1日至12月6日")]),
      ]),
      _vm._v(" "),
      _c("img", { attrs: { src: require("@/assets/kexie/regen/u35.svg") } }),
      _vm._v(" "),
      _c("div", { staticClass: "text-box cultivate" }, [
        _c("span", { staticClass: "title" }, [_vm._v("线上培训")]),
        _vm._v(" "),
        _c("span", [_vm._v("2020年12月8日至12月10日")]),
      ]),
      _vm._v(" "),
      _c("img", { attrs: { src: require("@/assets/kexie/regen/u35.svg") } }),
      _vm._v(" "),
      _c("div", { staticClass: "text-box cut-off" }, [
        _c("span", { staticClass: "title" }, [_vm._v("比赛日期")]),
        _vm._v(" "),
        _c("span", [_vm._v("2020年12月8日至12月31日")]),
      ]),
      _vm._v(" "),
      _c("img", { attrs: { src: require("@/assets/kexie/regen/u35.svg") } }),
      _vm._v(" "),
      _c("div", { staticClass: "text-box list" }, [
        _c("span", { staticClass: "title" }, [_vm._v("获奖名单公布")]),
        _vm._v(" "),
        _c("span", [_vm._v("2021月1月10日")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "activity-contest-title" }, [
      _c("span", { staticClass: "line" }),
      _vm._v(" "),
      _c("span", [_vm._v("设置赛项")]),
      _vm._v(" "),
      _c("span", { staticClass: "line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "smart" }, [
      _c("h4", [_vm._v("智能设计")]),
      _vm._v(" "),
      _c("div", { staticClass: "contest-card" }, [
        _c("img", {
          staticClass: "img",
          attrs: { src: require("@/assets/kexie/regen/u31.svg") },
        }),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://robosim.robotplayer.com/particular/" } },
          [
            _c("div", { staticClass: "card-btn-box" }, [
              _c("span", [_vm._v("我要报名")]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "card-type" }, [_vm._v("无人驾驶")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer" }, [
      _c("div", [
        _c("p", [_vm._v("主办单位：中国科协青少年科技中心")]),
        _vm._v(" "),
        _c("p", [_vm._v("运营维护：全国青少年科技创新服务平台")]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("网站备案：京ICP备11018462号-2 京公网安备11010802009524号"),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("联系我们：robot@xiaoxiaotong.org")]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "erweima",
        attrs: { src: require("@/assets/kexie/regen/u44.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/kexie/kexie.vue?vue&type=template&id=08d3020a&
// module id = null
// module chunks = 